import React from "react";
import { Modal, Spin, Typography } from "antd";
import { LoadingOutlined } from "@ant-design/icons";
import { useTranslation } from "react-i18next";
import styled from "styled-components";

import { fontWeights, sizes } from "../../../constant/styles";
import { GRAY_500, GRAY_900, PRIMARY_50, PRIMARY_700 } from "../../../constant/colors";

const { Text } = Typography;

const RetrievingModal = styled(Modal)`
  .ant-modal-content {
    border-radius: 12px;
  }
  .ant-modal-body {
    padding: 24px;
  }
`;

const Content = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 24px;
  min-height: 212px;
  justify-content: center;
`;

const FeaturedIcon = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 48px;
  height: 48px;
  border-radius: 50%;
  background: ${PRIMARY_50};
`;

const Title = styled(Text)`
  font-weight: ${fontWeights.semibold};
  font-size: ${sizes.large};
  color: ${GRAY_900};
`;

const Subtitle = styled(Text)`
  font-weight: ${fontWeights.regular};
  font-size: ${sizes.medium};
  color: ${GRAY_500};
  text-align: center;
`;

const RestoringPatientModal = ({ visible, onClose }) => {
  const { t } = useTranslation();

  return (
    <RetrievingModal
      centered
      open={visible}
      footer={null}
      width={520}
      onCancel={onClose}
      maskStyle={{ backgroundColor: "rgba(0, 0, 0, 0.75)", backdropFilter: "blur(4px)" }}
    >
      <Content role="status" aria-live="polite" data-testid="restoring-patient-modal">
        <FeaturedIcon>
          <Spin indicator={<LoadingOutlined style={{ fontSize: 28, color: PRIMARY_700 }} spin />} />
        </FeaturedIcon>
        <div style={{ display: "flex", flexDirection: "column", alignItems: "center", gap: 8 }}>
          <Title>{t("unarchive.retrieving_modal.title")}</Title>
          <Subtitle>{t("unarchive.retrieving_modal.subtitle")}</Subtitle>
        </div>
      </Content>
    </RetrievingModal>
  );
};

export default RestoringPatientModal;
